/**
 * The cases constants module houses cases-specific configurations.
 *
 * @module routes.cases.widgets.constants
 */

angular.module('routes.cases.widgets.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var widgets;


      /**
       * Defines widgets constants.
       *
       * @attribute WIDGETS
       * @type String
       * @readOnly
       */
      $provide.constant('WIDGETS', widgets);
    }
  ]);
